module.exports = __webpack_public_path__ + "media/images/icon_veedelsretter-82c6aac37d34bd45211e403b8b1c5f53.jpg";